import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  CircularProgress,
} from "@mui/material";

import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import Image from "next/image";
import useWindowSize from "utils/useWindowSize";
import Link from "next/link";
import { FaUserFriends, FaHandshake, FaStar } from "react-icons/fa";
import { MdHistoryEdu } from "react-icons/md";

// actions
import { getCoverList } from "context/actions/cover";
import { getProductList } from "/context/actions/product";
import { getCommentList } from "context/actions/comment";
import { getCategoriesAllList } from "context/actions/categories";

// components
import Slider from "components/Slider";
import MultiCardCarousel from "components/MultiCardCarousel";
import CommentCarousel from "components/CommentCarousel";
import WhyTravel from "components/WhyTravel";
import { fontSize, minHeight } from "@mui/system";

const HomePage = ({}) => {
  const { t } = useTranslation();

  const { sizes } = useWindowSize();
  const [covers, setCovers] = useState([]);
  const [tours, setTours] = useState([]);
  const [dataCategory, setCategory] = useState([]);
  const [comment, setComment] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    try {
      const resCover = await getCoverList();
      if (resCover.status === "success") setCovers(resCover.data);

      const resAll = await getCategoriesAllList();
      if (resAll.status === "success") setCategory(resAll.data);

      const resTours = await getProductList();
      if (resTours.status === "success") setTours(resTours.data.list);

      const resComment = await getCommentList();
      if (resComment.status === "success") setComment(resComment.data);

      setLoading(false); // Set loading to false once all data is loaded
    } catch (error) {
      console.error("Error loading data:", error);
      setLoading(false); // Set loading to false in case of error
    }
  };

  const items = [
    {
      icon: <FaUserFriends size={50} />,
      title: "100,000+",
      desc: "Аялагчдын сонголт",
    },
    {
      icon: <FaHandshake size={50} />,
      title: "100% Найдвартай",
      desc: "хамтрагчтай",
    },
    {
      icon: <MdHistoryEdu size={50} />,
      title: "since 2015",
      desc: "10 жилийн туршлагатай",
    },
    {
      icon: <FaStar size={50} />,
      title: "Аялагчдын сэтгэл ханамж",
      desc: "90 дээш хувь байдаг",
    },
  ];

  const contactLink = () => {};
  const contactBrochure = () => {};

  return (
    <Container maxWidth={false} disableGutters={true} className="bg-[#fafafa]">
      <Box>
        {loading ? (
          <Box
            className="flex justify-center items-center"
            style={{ height: "100vh" }} // Center the loader vertically
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Slider linkData={covers} />
            {dataCategory.map((item, ind) => {
              const filteredTours = tours.filter(
                (tour) => tour.category_id === item.id
              );
              return (
                <Box key={ind}>
                  <Box className="flex items-center justify-center mt-[-25px]">
                    <Box
                      className="px-4 text-center text-4xl text-[#545454] font-sans"
                      style={{
                        fontFamily: "Philosopher",
                        color: "#4f4235",
                        fontStyle: "bold",
                      }}
                    >
                      {item.name}
                    </Box>
                  </Box>
                  <Container maxWidth="lg" disableGutters>
                    <Box className="w-full mt-2.5 text-center text-[#545454] p-3.5 text-[14px]">
                      {item.comment}
                    </Box>
                  </Container>
                  {filteredTours.length > 0 && (
                    <MultiCardCarousel items={filteredTours} />
                  )}
                </Box>
              );
            })}

            <Box className="bg-[#efefef]">
              {/* <Box className="flex items-center justify-center">
                <Box
                  className="text-center text-4xl text-[#545454]"
                  style={{
                    fontFamily: '"Merriweather", serif',
                    fontStyle: "bold",
                    marginTop: 50,
                  }}
                >
                  Та яагаад биднийг сонгох ёстой вэ
                </Box>
              </Box> */}

              <section className="bg-gray-50 py-12">
                <div className="max-w-6xl mx-auto px-6">
                  <h2
                    className="text-center text-2xl md:text-3xl mb-10"
                    style={{
                      fontFamily: "Philosopher",
                      color: "#4f4235",
                      fontStyle: "bold",
                    }}
                  >
                    Та яагаад биднийг сонгох ёстой вэ
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {items.map((item, idx) => (
                      <div
                        key={idx}
                        className="bg-[#b07f50] text-white p-6 rounded-xl shadow-lg flex flex-col items-center text-center"
                      >
                        <div className="mb-4">{item.icon}</div>
                        <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                        <p>{item.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </Box>
            <Box
              className="text-center mt-10"
              style={{
                fontFamily: "Philosopher",
                color: "#4f4235",
                fontStyle: "bold",
                fontSize:30
              }}
            >
              Аялагчдын сэтгэгдэл
            </Box>
            <CommentCarousel items={comment} />
            {/* <Box className="bg-[#256c70] p-5">
              <Container maxWidth="lgs" disableGutters={true}>
                <Box className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center">
                  <Box className="p-5 text-center md:text-left">
                    <Box
                      className="text-center md:text-center mb-4 text-[#fff]"
                      style={{
                        fontFamily: '"Merriweather", serif',
                      }}
                    >
                      <Typography variant="h6">
                        Contact our itinerary specialist to <br /> plan your
                        tailor made tours to Mongolia
                      </Typography>
                    </Box>
                    <Box
                      className="text-justify text-center md:text-center text-[#fff] "
                      style={{ fontFamily: '"Merriweather", serif' }}
                    >
                      <Typography
                        variant="body1"
                        className="text-sm sm:text-base md:text-sm leading-relaxed"
                      >
                        Click the "Make an Enquiry" button to get in touch with
                        us
                      </Typography>
                    </Box>
                    <Box className="flex justify-center mt-5">
                      <Link href="/related" passHref>
                        <Button
                          className="bg-[#fff] text-[#717171] hover:bg-[#f0efec]"
                          onClick={contactLink}
                        >
                          Make an Enquiry
                        </Button>
                      </Link>
                    </Box>
                  </Box>
                  <Box className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <Box
                      className="w-[100px] sm:w-[120px] md:w-[140px] h-[100px] sm:h-[120px] md:h-[140px] rounded-full bg-cover bg-center mx-auto"
                      style={{
                        backgroundImage: "url(/pages/about/userImage.jpg)",
                      }}
                    ></Box>
                    <Box
                      className="w-[100px] sm:w-[120px] md:w-[140px] h-[100px] sm:h-[120px] md:h-[140px] rounded-full bg-cover bg-center mx-auto"
                      style={{
                        backgroundImage: "url(/pages/about/userImage2.jpg)",
                      }}
                    ></Box>
                    <Box
                      className="w-[100px] sm:w-[120px] md:w-[140px] h-[100px] sm:h-[120px] md:h-[140px] rounded-full bg-cover bg-center mx-auto"
                      style={{
                        backgroundImage: "url(/pages/about/last.jpg)",
                      }}
                    ></Box>
                  </Box>
                </Box>
              </Container>
            </Box> */}
            {/* <Box
              className=" p-10"
              style={{
                minHeight: 350,
                // height: 350,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
                backgroundImage: "url(/forImage.jpg)",
              }}
            >
              <Container maxWidth="lgs" disableGutters>
                <Box className="grid grid-cols-1 md:grid-cols-1 gap-3 items-center justify-center">
                  <Box className="grid grid-cols-1 md:grid-cols-2 gap-1 ">
                    <Box
                      className="mx-auto rotate-[-5deg] relative h-[250px]"
                      style={{
                        backgroundSize: "cover",
                        backgroundImage: "url(/pages/about/brocure.jpg)",
                      }}
                    >
                      <Box className="w-[160px] h-[240px] flex items-center justify-center text-[#fff] bg-cover bg-center mx-auto ">
                        <Box
                          style={{
                            marginTop: 40,
                            height: 50,
                            width: "100%",
                            backgroundSize: "cover",
                            borderRadius: 10,
                            backgroundImage: "url(/pages/about/11.png)",
                          }}
                        ></Box>
                        <Box
                          className="mx-auto rotate-[20deg] relative mt-5"
                          style={{
                            backgroundSize: "cover",
                            backgroundImage: "url(/pages/about/brocure.jpg)",
                          }}
                        >
                          <Box className="w-[160px] h-[240px] flex justify-center text-[#fff] bg-cover bg-center mx-auto">
                            <Box>
                              <Box
                                style={{
                                  marginTop: 90,
                                  height: 50,
                                  width: 160,
                                  backgroundSize: "cover",
                                  backgroundImage: "url(/pages/about/11.png)",
                                }}
                              ></Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="text-center text-[#fff] bg-cover bg-center">
                      <Box
                        className="text-center md:text-center mb-4 text-[#fff]"
                        style={{
                          fontFamily: '"Merriweather", serif',
                        }}
                      >
                        <Typography variant="h6">
                          For Your Next Adventure
                        </Typography>
                      </Box>
                      <Box
                        className="text-justify mt-5"
                        style={{ fontFamily: '"Merriweather", serif' }}
                      >
                        <Typography
                          variant="body1"
                          className="text-sm sm:text-base md:text-sm leading-relaxed"
                        >
                          "Embark on an unforgettable journey through Mongolia's
                          vast steppes, ancient traditions, and nomadic culture.
                          Request our brochure to explore curated itineraries,
                          exclusive experiences, and travel tips for a seamless
                          adventure. Let Mongolia's wonders captivate your
                          spirit— start planning today!"
                        </Typography>
                      </Box>
                      <Box className="flex justify-center mt-5">
                        <Link href="/brochure" passHref>
                          <Button
                            className="bg-[#fff] text-[#545454] hover:bg-[#f0efec] px-4 py-2"
                            onClick={contactBrochure}
                          >
                            Request a brochure
                          </Button>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Container>
            </Box> */}
            {/* <Box className="bg-[#e0e0e0] pb-[30px]"> */}
            {/* <Box className="bg-[#ededed] pb-[30px]">
              <Container maxWidth="lgs" disableGutters>
                <Box
                  className="text-center text-4xl text-[#545454]"
                  style={{
                    fontFamily: '"Merriweather", serif',
                    fontStyle: "bold",
                    paddingTop: 40,
                    paddingBottom: 40,
                  }}
                >
                  Why travel with Ezen Travel
                </Box>
                <WhyTravel />
              </Container>
            </Box> */}
          </>
        )}
      </Box>
    </Container>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
